import { render, staticRenderFns } from "./deUserProtocol.vue?vue&type=template&id=a5984690&scoped=true&"
import script from "./deUserProtocol.vue?vue&type=script&lang=js&"
export * from "./deUserProtocol.vue?vue&type=script&lang=js&"
import style0 from "./deUserProtocol.vue?vue&type=style&index=0&id=a5984690&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5984690",
  null
  
)

export default component.exports